// hooks/useKeyboardNavigation.js
import { useCallback, useEffect } from 'react';

export const useKeyboardNavigation = (focusedRow, finalDisplayNotes, onNavigate, onAddFromSelected) => {
  const handleKeyDown = useCallback(
    (e) => {
      if (!focusedRow) return;
      const currentIndex = finalDisplayNotes.findIndex((n) => n.id === focusedRow);
      
      if (e.key === "ArrowDown") {
        e.preventDefault();
        const nextIndex = Math.min(currentIndex + 1, finalDisplayNotes.length - 1);
        if (nextIndex !== currentIndex) {
          onNavigate(finalDisplayNotes[nextIndex].id);
        }
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        const prevIndex = Math.max(currentIndex - 1, 0);
        if (prevIndex !== currentIndex) {
          onNavigate(finalDisplayNotes[prevIndex].id);
        }
      } else if (e.ctrlKey && e.key === "a" && focusedRow) {
        e.preventDefault();
        const selectedNote = finalDisplayNotes.find((n) => n.id === focusedRow);
        if (selectedNote) {
          onAddFromSelected(selectedNote);
        }
      }
    },
    [focusedRow, finalDisplayNotes, onNavigate, onAddFromSelected]
  );

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [handleKeyDown]);
};